import { createContext } from 'react';

const ColorModeContext = createContext({
  darkMode: false,
  toggleDarkMode: () => {},
});
export default ColorModeContext;
